// extracted by mini-css-extract-plugin
module.exports = {"plainListItem":"plain-list-module--plain-list-item--1fg5z","plainListDemo":"plain-list-module--plain-list--demo--3T3KW"};